import { render, staticRenderFns } from "./ExtraCategoriesManage.vue?vue&type=template&id=b2c04f04&scoped=true&"
import script from "./ExtraCategoriesManage.vue?vue&type=script&lang=js&"
export * from "./ExtraCategoriesManage.vue?vue&type=script&lang=js&"
import style0 from "./ExtraCategoriesManage.vue?vue&type=style&index=0&id=b2c04f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c04f04",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VForm,VIcon,VTextField})
